import { Moment } from 'moment';
import { ComposicaoRda } from './composicao-rda.model';

export class Responsavel {

  id: number;
  idPessoa: number;
  idUnico: number;
  numeroTelefoneResponsavel: number;
  dataCadastro: Moment;
  dataInativacao: Moment;
  composicaoRda: ComposicaoRda;
  email: string;
  nome: string;
  cpf: string;
  icEstrangeiro: boolean;
  icPessoaAtiva: boolean;

  constructor(init?: Partial<Responsavel>) {
    Object.assign(this, init);
  }
}
